import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    bank,
    taxId,
    totalTax,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [firstTime.name]: "",
  [supplementaryForThe.name]: "",
  [bank.name]: "",
  [totalTax.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
